module.exports = __webpack_public_path__ + "0ee3f48c33f91ff5557d28cbe9b3b697.png";